<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="actionUrl"
  id="bundleForm"
  :reset="true"
  v-on:submit.prevent="submit"
>
  <div class="form-group">
    <label for="bundle-name">
      Name
    </label>
    <input
      type="text"
      name="puzzle_bundle[name]"
      id="bundle-name"
      v-model="name"
      class="form-control"
      required
    />
  </div>

  <div class="form-group">
    <label for="bundle-summary">
      Summary
    </label>
    <input
      type="text"
      name="puzzle_bundle[summary]"
      id="bundle-summary"
      v-model="summary"
      class="form-control"
    />
  </div>

  <div class="form-group">
    <label for="bundle-description">
      Description
    </label>
    <textarea
      name="puzzle_bundle[description]"
      id="bundle-description"
      v-model="description"
      class="form-control"
    />
  </div>

  <div class="form-group row">
    <div class="col-sm-2">
      <label for="bundle-difficulty">
        Difficulty Level
      </label>
    </div>
    <div class="col-2">
      <input
        type="number"
        name="puzzle_bundle[difficulty]"
        id="bundle-difficulty"
        class="form-control"
        v-model="difficulty"
      />
      <p
        class="alert alert-warning text-center p-0"
      >
        <small>
          Between 1-100. Use -1 for no assigned difficulty.
        </small>
      </p>
    </div>
    <div class="col-sm-2">
      <label for="bundle-puzzle-count">
        Puzzle Count
      </label>
    </div>
    <div class="col-2">
      <input
        type="number"
        name="puzzle_bundle[puzzle_count]"
        id="bundle-puzzle-count"
        class="form-control"
        v-model="puzzle_count"
      />
      <p
        class="alert alert-warning text-center p-0"
      >
        <small>
          Auto-generated based on AcrossLite files.
        </small>
      </p>
    </div>
    <div class="col-sm-2">
      <label
        for="bundle-price"
      >
        Price
      </label>
    </div>
    <div class="col-2">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">$</span>
        </div>
        <input
          type="number"
          name="puzzle_bundle[price]"
          id="puzzle-bundle-price"
          step=".01"
          v-model="price"
          class="form-control"
          placeholder
          required
        />
      </div>
      <p
        class="alert alert-warning text-center p-0"
      >
        <small>
          $0.00 for free
        </small>
      </p>
    </div>
  </div>

  <div
    class="form-group row"
  >
    <div class="col-sm-2">
      <div class="form-check">
        <label class="form-check-label" for="bundle-inactive">
          <input type="hidden" name="puzzle_bundle[inactive]" value="false" />
          <input
            type="checkbox"
            name="puzzle_bundle[inactive]"
            id="bundle-inactive"
            class="form-check-input"
            v-model="inactive"
          />
          Inactive?
        </label>
      </div>
    </div>
    <div class="col-sm-2">
      <div class="form-check">
        <label class="form-check-label" for="bundle-public">
          <input type="hidden" name="puzzle_bundle[public]" value="false" />
          <input
            type="checkbox"
            name="puzzle_bundle[public]"
            id="bundle-public"
            class="form-check-input"
            v-model="public"
          />
          Visible?
        </label>
      </div>
    </div>
  </div>
  <div
    class="row"
  >
    <div
      class="col-12"
    >
      <div
        id="puzzle-bundle-archive"
        v-if="!hasAttachments"
      >
        <label for="puzzle-bundle-archive">
          Upload Bundle Archives
        </label>
        <input
          type="file"
          name="puzzle_bundle[archive_file]"
          id="puzzle-bundle-archive"
          class="puzzle-bundle-archive"
        />
        <p
          class="alert alert-warning text-center"
          role="alert"
        >
          Files should be no larger than 10MB
        </p>
        <p>
          <input
            type="checkbox"
            name="puzzle_bundle[import_puzzles]"
            id="puzzle-bundle-import-puzzles"
            value="true"
          />

          <label
            for="puzzle-bundle-import-puzzles"
          >
            Import puzzles for subscriber access?
          </label>
        </p>
      </div>
      <div
        v-else
      >
        <p
          class="alert alert-warning text-center"
        >
          Bundle files can be edited/added via the
            <router-link
              :to="{
                name: 'edit_purchasable_item',
                params: {
                  purchasableItemId: purchasable_item.id
                }
              }"
            >
              bundle's purchasable item
            </router-link> attachments.
        </p>
      </div>

      <p
        class="divider text-center"
      >
        <strong>OR</strong>
      </p>

      <div
        class="form-group"
      >
        <p>
          Create a bundle archive via a puzzle date range:
        </p>

        <div
          class="row"
        >
          <div
            class="col-6"
          >
            <label
              for="puzzle_bundle_start_at"
            >
              Start Date
            </label>

            <input
              type="date"
              class="form-control"
              id="puzzle_bundle_start_at"
              name="puzzle_bundle[start_at]"
              v-model="formattedStartAt"
            />
          </div>
          <div
            class="col-6"
          >
            <label
              for="puzzle_bundle_end_at"
            >
              End Date
            </label>

            <input
              type="date"
              class="form-control"
              id="puzzle_bundle_end_at"
              name="puzzle_bundle[end_at]"
              v-model="formattedEndAt"
            />
          </div>
        </div>
        <p
          class="alert alert-danger text-center"
          v-if="compileArchiveConfirm"
        >
          <input
            type="checkbox"
            id="compile_archive_confirmation"
            v-model="compileArchiveConfirmed"
          />

          <label
            for="compile_archive_confirmation"
          >
            Please confirm that you are aware using this feature will replace all of the bundle's existing files.
          </label>
        </p>
      </div>
    </div>
  </div>

  <div class="row">
    <button
      type="submit"
      class="form-control btn btn-primary"
    >
      {{ actionLbl }} Bundle
      <spinner size="small" v-if="loading" />
    </button>
  </div>

</form>
</template>

<script>
import BundleStore from '@/stores/BundleStore'

import Spinner from 'vue-simple-spinner'

export default {
  data () {
    let state = BundleStore.state
    state.compileArchiveConfirm = false
    state.compileArchiveConfirmed = undefined
    state.loading = false

    return state
  },

  components: {
    'spinner': Spinner
  },

  computed: {
    actionLbl () {
      return this.bundleId ? 'Edit' : 'Create'
    },

    actionUrl () {
      return this.apiUrl(
        '/puzzle_bundles' + (this.bundleId ? ('/' + this.bundleId) : ''),
        true
      )
    },

    formattedStartAt: {
      get () {
        return this.$root.dateFmt(this.start_at)
      },

      set (val) {
        this.compileArchiveConfirm = true
        const newStr = this.$root.setDate(val)
        this.start_at = newStr
      }
    },

    formattedEndAt: {
      get () {
        return this.$root.dateFmt(this.end_at)
      },

      set (val) {
        this.compileArchiveConfirm = true
        const newStr = this.$root.setDate(val)
        this.end_at = newStr
      }
    },

    hasAttachments () {
      return this.purchasable_item.attributes && this.purchasable_item.attributes.purchasable_item_attachments.length
    },

    hasConfirmed () {
      return (
        !this.compileArchiveConfirm || this.compileArchiveConfirmed
      )
    },

    methodType () {
      return this.bundleId ? 'PUT' : 'POST'
    }
  },

  props: [
    'bundleId', 'method', 'action'
  ],

  methods: {
    submit (ev) {
      if (this.hasConfirmed) {
        this.loading = true

        this.bindSubmit(ev).then((response) => {
          this.loading = false
          const bundleId = response.body.data.id

          this.$router.push({
            name: 'bundle',
            params: {
              bundleId: bundleId
            }
          })
        }, this.$parent.processErrors)
      } else {
        alert('Please confirm that you want to replace the pre-existing bundle files.')
      }
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/components/BundleForm.vue